<template>
  <div id="contenedor-main-actividades">
    <tool-bar
      v-if="mostrarToolBar"
      class="my-3"
      v-on:crearActividad="mostrarCrearActividad = true"
    />
    <listado
    :listadoActividades="getActividades"
    :soloLectura="soloLectura"
    :tipoLista="tipoLista"
    />
    <v-dialog v-model="mostrarCrearActividad" width="900">
      <crear-actividad
        :idReferenciaActividad="idReferencia"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog
      v-if="estaActividad"
      v-model="mostrarEditarActividad"
      width="900"
    >
      <editar-actividad
        :actividadEditar="estaActividad"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog
      v-if="estaActividad"
      v-model="mostrarEliminarActividad"
      width="500"
    >
      <eliminar-actividad
        :actividadEliminar="estaActividad"
        :idReferenciaActividad="idReferencia"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
import ACTIVIDADES from '@/graphql/querys/administracion/actividades/actividades.gql';
import CrearActividad from '@/components/administracion/actividades/Nueva.vue';
import EditarActividad from '@/components/administracion/actividades/Editar.vue';
import EliminarActividad from '@/components/administracion/actividades/Eliminar.vue';

import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ActividadesMain',
  props: {
    idReferencia: {
      type: String,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
    tipoLista: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ToolBar,
    Listado,
    CrearActividad,
    EliminarActividad,
    EditarActividad,
  },
  data() {
    return {
      mostrarCrearActividad: false,
      mostrarEditarActividad: false,
      mostrarEliminarActividad: false,
      estaActividad: null,
    };
  },
  apollo: {
    actividades: {
      query: ACTIVIDADES,
      variables() {
        return {
          idReferencia: this.idReferencia,
        };
      },
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarCrearActividad = false;
      this.mostrarEditarActividad = false;
      this.mostrarEliminarActividad = false;
      this.estaActividad = null;
    },
  },
  computed: {
    getActividades() {
      if (!this.actividades) return [];
      return this.actividades;
    },
    mostrarToolBar() {
      if (this.soloLectura || this.tipoLista) return false;
      return true;
    },
  },
  mounted() {
    eventBus.$on('editar-actividad', (actividad) => {
      this.estaActividad = actividad;
      this.mostrarEditarActividad = true;
    });
    eventBus.$on('borrar-actividad', (actividad) => {
      this.estaActividad = actividad;
      this.mostrarEliminarActividad = true;
    });
  },
};
</script>

<style lang="scss">
</style>
